import yup from 'validator';

const schema = yup.object({
    selectedTVPrograms: yup.array(yup.object()).default([]).label('Programas de TV'),
    selectedRadioPrograms: yup.array(yup.object()).default([]).label('Programas de Rádio'),
});

export default schema;
